const CONSENT_EXPIRATION_DAYS = 180;
const STORAGE_KEY_PREFIX = "eaktywni_cookie_consent_";

export interface CookieConsent {
  necessary: true;
  optional: boolean;
  createdAt: string;
  expiresAt: string;
}

function buildStorageKey(facilityId: string): string {
  return `${STORAGE_KEY_PREFIX}${facilityId}`;
}

export function getConsent(facilityId: string): CookieConsent | null {
  if (!facilityId) return null;
  try {
    const raw = localStorage.getItem(buildStorageKey(facilityId));
    if (!raw) return null;

    const consent: CookieConsent = JSON.parse(raw);

    if (!consent.expiresAt || new Date(consent.expiresAt) < new Date()) {
      localStorage.removeItem(buildStorageKey(facilityId));
      return null;
    }

    return consent;
  } catch {
    localStorage.removeItem(buildStorageKey(facilityId));
    return null;
  }
}

export function saveConsent(facilityId: string, optional: boolean): void {
  if (!facilityId) return;
  const now = new Date();
  const expiresAt = new Date();
  expiresAt.setDate(now.getDate() + CONSENT_EXPIRATION_DAYS);

  const consent: CookieConsent = {
    necessary: true,
    optional,
    createdAt: now.toISOString(),
    expiresAt: expiresAt.toISOString(),
  };

  localStorage.setItem(buildStorageKey(facilityId), JSON.stringify(consent));
}

export function clearConsent(facilityId: string): void {
  if (!facilityId) return;
  localStorage.removeItem(buildStorageKey(facilityId));
}
